const ChargePointsVisibility = [
  { name: "PUBLIC", value: "PUBLIC" },
  { name: "PRIVATE", value: "PRIVATE" },
];
const ChargePointsTypeOfCharger = [
  { name: "AC Charger", value: "AC" },
  { name: "DC Charger", value: "DC" },
];

export const chargePointDrawerSelectOptions = [
  {
    label: "Name",
    placeholder: "Name",
    name: "Name",
    type: "input",
  },
  {
    label: "Charger Id",
    placeholder: "Charger Id",
    name: "StationId",
    type: "input",
  },
  // {
  //   label: "Description",
  //   placeholder: "Description",
  //   name: "Description",
  //   type: "input",
  // },
  {
    label: "Visibility",
    placeholder: "Visibility",
    name: "Visibility",
    type: "select",
    options: ChargePointsVisibility,
  },
  {
    label: "Type of Charger",
    placeholder: "Type of Charger",
    name: "PowerType",
    type: "select",
    options: ChargePointsTypeOfCharger,
  },
  {
    label: "Power (kWh)",
    placeholder: "Power",
    name: "MaxElectricPower",
    type: "input",
  },
];

export const createChargePointDrawerSelectOptions = [
  {
    label: "Name",
    placeholder: "Name",
    name: "Name",
    type: "input",
  },
  {
    label: "Charger Id",
    placeholder: "Charger Id",
    name: "StationId",
    type: "input",
  },
  {
    label: "Tariff",
    placeholder: "Tariff",
    name: "Tariff",
    type: "input",
  },
  {
    label: "Visibility",
    placeholder: "Visibility",
    name: "Visibility",
    type: "select",
    options: ChargePointsVisibility,
  },
  {
    label: "Type of Charger",
    placeholder: "Type of Charger",
    name: "PowerType",
    type: "select",
    options: ChargePointsTypeOfCharger,
  },
  {
    label: "Power",
    placeholder: "Power",
    name: "MaxElectricPower",
    type: "input",
  },
];
